import { Component, Input } from "@angular/core";
import { GameType, MagicCard } from "@apiserver-rest/ponder-data-client-base";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { getHistoryRoute } from "@ponder-features/user/history/history-router";
import { environment } from "../../../../environments/environment";
import { NgClass } from "@angular/common";

@Component({
    selector: "magic-card-links",
    imports: [NgClass],
    templateUrl: "./magic-card-links.component.html"
})
export class MagicCardLinksComponent {
    @Input({ required: true }) public username?: string;
    @Input({ required: true }) public magicCard!: MagicCard;

    public readonly clockSvgIcon: string = SvgIconMap.get(SvgIcon.Clock)!;
    public readonly magicSvgIcon: string = SvgIconMap.get(SvgIcon.MagicTCG)!;
    public readonly tcgplayerSvgIcon: string = SvgIconMap.get(SvgIcon.TCGplayer)!;
    public readonly scryfallSvgIcon: string = SvgIconMap.get(SvgIcon.Scryfall)!;

    public historyUrl?: string;
    public gathererUrl?: string;
    public scryfallUrl?: string;
    public tcgPlayerUrl?: string;

    public ngOnInit(): void {
        if (this.username) {
            this.historyUrl = getHistoryRoute(GameType.Magic, 0, undefined, undefined, this.magicCard.name!, true);
        }

        if (this.magicCard.mvId && this.magicCard.mvId > 0) {
            this.gathererUrl = `https://gatherer.wizards.com/Pages/Card/Details.aspx?multiverseid=${this.magicCard.mvId!}`;
        }

        this.scryfallUrl = `https://scryfall.com/card/${this.magicCard.scryfallId!}`;

        if (this.magicCard.tcgplayerId) {
            this.tcgPlayerUrl = `${environment.tcgplayer.affiliateUrl}?u=${encodeURIComponent(`https://www.tcgplayer.com/product/${this.magicCard.tcgplayerId}`)}`;
        } else {
            this.tcgPlayerUrl = `${environment.tcgplayer.affiliateUrl}?u=${encodeURIComponent(`https://www.tcgplayer.com/search/magic/product?productLineName=magic&q=${this.magicCard.name!.toLowerCase()}`)}`;
        }
    }
}